import { connect } from 'react-redux';
import { getFormValues } from 'redux-form';
import RevisionItemHeader from '../components/RevisionItemHeader';

const mapStateToProps = (state, ownProps) => ({
  formRevision: getFormValues('revisions')(state).revisions[ownProps.revision.id]
});

export default connect(mapStateToProps)(RevisionItemHeader);
